



















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
@Component({
  components: {}
})
export default class P0929 extends Vue {
  tabStatus: string = 'electricity';
}
